import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { convertToInteger } from './../../../../modules/shared/validators/convert-to-integer.validator';
import { convertToAbsolute } from './../../../../modules/shared/validators/convert-to-absolute.validator';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { TypeService } from './../../../../modules/shared/api/type.service';
import { SharedTaskService } from './../../../../modules/shared/components/shared-task/shared-task.service';
import { AppMainService } from './../../../../app-main.service';
import { AppMainComponent } from './../../../../app.main.component';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DocumentViewerService } from './../../../../modules/shared/services/document-viewer.service';
import { MyDocumentsService } from './../../../../profile/my-documents/my-documents.service';
import { saveAs } from "file-saver";
import { Status } from 'src/app/modules/shared/models/status';
import { uploadFiles, validateFiles } from 'src/app/modules/shared/upload-files';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TaskCategoryService } from 'src/app/shared/api/taskCategory.service';

@Component({
    selector: 'app-workflow-task-add-dialog',
    templateUrl: './workflow-task-add-dialog.component.html',
    styleUrls: ['./workflow-task-add-dialog.component.scss'],
    providers: [TypeService, TaskCategoryService]
})
export class WorkflowTaskAddDialogComponent implements OnInit, OnDestroy, OnChanges {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() viewOnly: boolean = false;
    @Input() displayAddTask: boolean = false;
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() selectedActionTask: WorkflowModelsNS.WorkflowAddEditActionTask = null;
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() taskSaved = new EventEmitter<WorkflowModelsNS.WorkflowAddEditActionTask>();

    //Attachments
    mimeTypes = [
        { extension: "csv", value: "text/csv" },
        { extension: "doc", value: "application/msword" },
        { extension: "docx", value: "application/msword" },
        { extension: "gif", value: "image/gif" },
        { extension: "jpeg", value: "image/jpeg" },
        { extension: "jpg", value: "image/jpeg" },
        { extension: "png", value: "image/png" },
        { extension: "pdf", value: "application/pdf" },
        { extension: "ppt", value: "application/vnd.ms-powerpoint" },
        { extension: "pptx", value: "application/vnd.ms-powerpoint" },
        { extension: "rar", value: "application/x-rar-compressed" },
        { extension: "xls", value: "application/msexcel" },
        { extension: "xlsx", value: "application/msexcel" },
        { extension: "zip", value: "application/zip" },
        { extension: "txt", value: "text/plain" }
    ];
    allowedExtensions = ['.pdf', '.csv', '.txt', '.xlsx', '.xls', '.docx', '.doc', '.png', '.jpg', '.jpeg', '.ppt', '.pptx', '.gif', '.zip']; // For the attachment files
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
        <li>Files with extensions: doc, docx, pdf, xls, xlsx, txt, gif, jpeg are allowed</li>
    </ul> `;
    attachments: WorkflowModelsNS.WorkflowTaskActionAttachments[] = [];
    displayFilePreview: boolean = false;
    currentFile: any = null;

    //Task Data
    taskAddEditHeader: 'Add Task' | 'Edit Task' | 'View Task' = 'Add Task';
    taskAddData: WorkflowModelsNS.WorkflowAddEditActionTask;

    //Dropdown List
    assignDD: any[] = [];
    operatorDD: any[] = [];
    status: any[] = [];

    startBaseFields = [
        {
            name: 'Execution Date',
            fieldName: 'ExecutionDateTime'
        }
    ];

    addOrSubstractBases = [
        // { id:1, name:"Before" },
        { id: 2, name: "After" },
    ];

    occurrenceTypes = [
        { id: 1, name: "Years" },
        { id: 2, name: "Months" },
        { id: 3, name: "Days" },
        { id: 4, name: "Hours" },
        { id: 5, name: "Minutes" },
        { id: 6, name: "Seconds" },
    ];

    assignedTypes = [
        {
            id: 1,
            name: 'Users'
        },
        // {
        //     id: 2,
        //     name: 'Roles'
        // }
    ];

    activeUsers: any[] = [];
    taskCategories: any[] = [];
    reminderDelay: any[] = [];
    reminderTypes: any[] = [];
    repeat: any[] = [];
    priority: any[] = [];

    //Group Task
    taskTypes: any[] = [
        { id: WorkflowModelsNS.WorkflowTaskTypesEnum.IndividualTask, name: 'Single Task' },
        { id: WorkflowModelsNS.WorkflowTaskTypesEnum.GroupTask, name: 'Multiple Task' }
    ];

    //Workflow details form
    taskDetailsForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    displayAddEditList: boolean = false;

    //Group Task Form
    @ViewChild('editor') editor: any;
    groupChildTasks: WorkflowModelsNS.WorkflowAddEditActionChildTasks[] = [];
    groupTaskHeader: string = 'Add Task';
    displayGroupTaskAddEdit: boolean = false;
    taskGroupIndex: number = -1;
    groupTaskDetailsForm: FormGroup = new FormGroup({});
    groupDetailsFormErrors: any = {};
    groupTaskErrorMsg: string = "";
    groupFormErrorHandler: FormErrorHandler = new FormErrorHandler();

    //defaultValues
    defaultValuesData:any;

    constructor(
        private formBuilder: FormBuilder,
        private renderer: Renderer2,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private taskService: SharedTaskService,
        private taskCategoryService: TaskCategoryService,
        private typeService: TypeService,
        private documentsService: MyDocumentsService,
        private documentViewerService: DocumentViewerService,
    ) { }

    ngOnInit(): void {
        this.initTaskForm();
        this.initGroupTaskDetailsForm();
        this.loadDropdownValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedParentModule'] && changes['selectedParentModule']?.currentValue) {
            this.selectedParentModule = changes['selectedParentModule']?.currentValue;
        }

        if (changes['displayAddTask'] && changes['displayAddTask']?.currentValue) {
            this.loadPreLoadedData();
        }

        if (changes['selectedActionTask'] && changes['selectedActionTask']?.currentValue) {
            this.selectedActionTask = changes['selectedActionTask']?.currentValue;
            this.setTaskEditData(this.selectedActionTask);
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    dialogClose() {
        this.taskDetailsForm.enable();
        this.initTaskForm();
        this.setFormInitialValue();
        this.displayAddTask = false;
        this.dialogClosed.emit(true);
    }

    //Task Form
    initTaskForm() {
        this.taskAddEditHeader = 'Add Task';
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.attachments = [];
        this.groupChildTasks = [];
        this.taskDetailsForm = this.formBuilder.group({
            id: [0],
            startDateBaseField: [{ value: this.startBaseFields[0], disabled: true }],
            selectedAddOrSubstractBase: [this.addOrSubstractBases[0], [Validators.required]],
            startDateAddOrSubstractValue: [0, [Validators.required, convertToAbsolute, convertToInteger]],
            endDateAddOrSubstractValue: [5, [Validators.required, convertToAbsolute, convertToInteger]],
            taskTitle: ["", [Validators.maxLength(256)]],
            description: ["", [Validators.required]],
            assignedType: [this.assignedTypes[0], [Validators.required]],
            selectedUsers: [null, [Validators.required]],
            selectedSharedWithUsers: [null],
            taskCategory: [null, [Validators.required]],
            reminderType: [null, [Validators.required]],
            reminder: [null, [Validators.required]],
            repeatType: [null, [Validators.required]],
            priority: [null, [Validators.required]],
            taskTypeId: [this.taskTypes[0].id, [Validators.required]],
            isTaskOrdered: [false]
        });

        this.formErrorHandler.handleErrors(this.taskDetailsForm, this.detailsFormErrors, {
            startDateAddOrSubstractValue: {
                required: "Enter start day",
            },
            endDateAddOrSubstractValue: {
                required: "Enter end day",
                min: "End day can't be less than start day"
            },
            taskTitle: {
                maxlength: "Enter less than 256 characters",
                required: "Enter Task Title",
            },
            description: {
                maxlength: "Enter less than 500 characters",
                required: "Enter Task Details",
            },
            selectedUsers: {
                required: "Select any user",
            },
            taskCategory: {
                required: "Select task category",
            },
            reminderType: {
                required: "Select reminder type",
            },
            reminder: {
                required: "Select reminder",
            },
            repeatType: {
                required: "Select task repeat type",
            },
            validFromDate: {
                required: "Select any start date",
            },
            priority: {
                required: "Select priority",
            }
        });

        this.taskDetailsForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);

        this.taskDetailsForm.get('taskTypeId')?.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(value => {
            this.setFieldsValidation(value);
        });
    }

    setFieldsValidation(taskTypeId: number) {
        const assignedType = this.taskDetailsForm.get('assignedType');
        const selectedUsers = this.taskDetailsForm.get('selectedUsers');
        const description = this.taskDetailsForm.get('description');
        const endDateAddOrSubstractValue = this.taskDetailsForm.get('endDateAddOrSubstractValue');

        if (taskTypeId == WorkflowModelsNS.WorkflowTaskTypesEnum.IndividualTask) {
            assignedType?.setValidators([Validators.required]);
            selectedUsers?.setValidators([Validators.required]);
            description?.setValidators([Validators.required]);
            endDateAddOrSubstractValue?.setValidators([Validators.required]);
        } else {
            assignedType?.setValidators([]);
            selectedUsers?.setValidators([]);
            description?.setValidators([]);
            endDateAddOrSubstractValue?.setValidators([]);
        }

        assignedType?.updateValueAndValidity();
        selectedUsers?.updateValueAndValidity();
        description?.updateValueAndValidity();
    }

    setFormInitialValue() {
        this.taskDetailsForm.patchValue({
            repeatType: this.repeat?.length > 0 ? this.repeat[0] : null,
            reminder: this.reminderDelay?.length > 0 ? this.reminderDelay[0] : null,
            priority: this.priority?.length > 0 ? this.priority[0] : null,
            reminderType: this.reminderTypes?.length > 0 ? this.reminderTypes[0] : null,
            taskCategory: this.taskCategories?.length > 0 ? this.taskCategories[0] : null
        })
    }

    setTaskEditData(selectedActionTask: WorkflowModelsNS.WorkflowAddEditActionTask) {
        this.taskAddEditHeader = this.viewOnly ? 'View Task' : 'Edit Task';
        const selectedUsers = [];
        this.selectedActionTask.workflowActionTaskAssignees.filter(c => c.statusId == 1).map(userDetails => {
            const selectedUser = this.activeUsers.find(user => user.id == userDetails.userId);
            if (selectedUser) selectedUsers.push(selectedUser);
        });

        const selectedSharedWithUsers = [];
        this.selectedActionTask.workflowActionTaskSharedWiths.filter(c => c.statusId == 1).map(userDetails => {
            const selectedSharedUser = this.activeUsers.find(user => user.id == userDetails.userId);
            if (selectedSharedUser) selectedSharedWithUsers.push(selectedSharedUser);
        })

        this.attachments = selectedActionTask.workflowTaskAttachments?.length > 0 ? selectedActionTask.workflowTaskAttachments.filter(attachment => attachment.statusId == Status.Active) : [];
        this.groupChildTasks = (selectedActionTask && selectedActionTask?.workflowActionChildTasks?.length > 0) ? selectedActionTask.workflowActionChildTasks.filter(childTask => childTask.statusId == Status.Active) : [];

        if (this.groupChildTasks?.length > 0) {
            this.groupChildTasks = this.groupChildTasks.sort((a, b) => a.taskOrder - b.taskOrder);
            this.groupChildTasks.map(childTask => {
                childTask.workflowActionChildTaskAssignees.map(assignee => {
                    assignee.name = assignee?.name || this.activeUsers.find(user => user.id == assignee.userId)?.name;
                })
            })
        }

        this.taskDetailsForm.patchValue({
            id: selectedActionTask.id,
            taskTypeId: selectedActionTask?.taskTypeId || this.taskTypes[0].id,
            isTaskOrdered: selectedActionTask?.isTaskOrdered || false,
            startDateAddOrSubstractValue: selectedActionTask.startDateAddOrSubstractValue || 0,
            endDateAddOrSubstractValue: selectedActionTask.endDateAddOrSubstractValue || 5,
            taskTitle: selectedActionTask?.taskTitle || '',
            description: selectedActionTask.description || '',
            selectedUsers: selectedUsers || null,
            selectedSharedWithUsers: selectedSharedWithUsers || null,
            repeatType: this.repeat?.length > 0 ? this.repeat.find(c => c.id === selectedActionTask.repeatTypeId) || this.repeat[0] : null,
            reminder: this.reminderDelay?.length > 0 ? this.reminderDelay.find(c => c.id === selectedActionTask.reminderInMinutes) || this.reminderDelay[0] : null,
            priority: this.priority?.length > 0 ? this.priority.find(c => c.id === selectedActionTask.prority) || this.priority[0] : null,
            reminderType: this.reminderTypes?.length > 0 ? this.reminderTypes.find(c => c.id === selectedActionTask.reminderTypeId) || this.reminderTypes[0] : null,
            taskCategory: this.taskCategories?.length > 0 ? this.taskCategories.find(c => c.id === selectedActionTask.taskCategoryId) || this.taskCategories[0] : null
        })

        if (this.viewOnly) {
            this.taskDetailsForm.disable();
        } else {
            this.taskDetailsForm.enable();
        }
    }

    saveTask() {

        if (this.taskDetailsForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        if (this.taskDetailsForm.getRawValue().taskTypeId == WorkflowModelsNS.WorkflowTaskTypesEnum.GroupTask && this.groupChildTasks?.length == 0) {
            this.groupTaskErrorMsg = "Please add any task";
            this.scrollToError();
            return;
        }

        const formData = this.taskDetailsForm.getRawValue();

        const taskData: WorkflowModelsNS.WorkflowAddEditActionTask = {
            id: this.selectedActionTask?.id || 0,
            workflowActionId: this.selectedActionTask?.workflowActionId || 0,
            taskTypeId: formData.taskTypeId,
            messageTemplateId: this.selectedActionTask?.messageTemplateId || 0,
            taskTitle: formData.taskTitle || "",
            description: formData.description || "",
            startDateBaseFieldName: this.taskDetailsForm.getRawValue().startDateBaseField.fieldName,
            addOrSubstractBase: WorkflowModelsNS.WorkflowOccurrenceTypsEnum.Days,
            addOrSubstractBaseName: formData.selectedAddOrSubstractBase?.name || "",
            startDateAddOrSubstractValue: formData.startDateAddOrSubstractValue,
            endDateAddOrSubstractValue: formData.endDateAddOrSubstractValue,
            assignedType: formData.assignedType?.id || 1,
            taskCategoryId: formData.taskCategory?.id || null,
            taskCategoryName: formData.taskCategory?.category?.name || null,
            reminderTypeId: formData.reminderType?.id || null,
            repeatTypeId: formData.repeatType?.id || null,
            reminderInMinutes: formData.reminder?.id || null,
            prority: formData.priority?.id || null,
            prorityName: formData.priority?.priority || null,
            workflowActionTaskAssignees: [],
            workflowActionTaskSharedWiths: [],
            isTaskOrdered: formData.isTaskOrdered,
            workflowActionChildTasks: this.groupChildTasks || [],
            workflowTaskAttachments: this.attachments || []
        }

        if (taskData.taskTypeId == WorkflowModelsNS.WorkflowTaskTypesEnum.IndividualTask) {
            const selectedUsers = formData?.selectedUsers || [];
            selectedUsers.map(userDetails => {

                let id = 0;

                if (this.selectedActionTask) {
                    const addedUser = this.selectedActionTask.workflowActionTaskAssignees.find(user => user.userId == userDetails.id);
                    id = addedUser ? addedUser.id : 0;
                }

                taskData.workflowActionTaskAssignees.push({
                    id: id,
                    workflowActionTaskId: taskData.id,
                    userId: userDetails.id,
                    statusId: 1
                })
            });

            taskData.workflowActionChildTasks = [];
            taskData.isTaskOrdered = false;
        } else {
            const maxTask = this.groupChildTasks.reduce((max, current) => {
                return current.endDateAddOrSubstractValue > max.endDateAddOrSubstractValue ? current : max;
            });
            taskData.endDateAddOrSubstractValue = maxTask.endDateAddOrSubstractValue;
            taskData.description = "";
            taskData.workflowActionChildTasks.map((childTask, index) => {
                childTask.taskOrder = index;
            })
        }

        //Shared With Tasks
        this.taskDetailsForm.value?.selectedSharedWithUsers?.map(userDetails => {

            let id = 0;

            if (this.selectedActionTask) {
                const addedUser = this.selectedActionTask.workflowActionTaskSharedWiths.find(user => user.userId == userDetails.id);
                id = addedUser ? addedUser.id : 0;
            }

            taskData.workflowActionTaskSharedWiths.push({
                id: id,
                workflowActionTaskId: taskData.id,
                userId: userDetails.id,
                statusId: 1
            })
        });

        //Set removed
        if (this.selectedActionTask) {
            this.selectedActionTask.workflowActionTaskAssignees.filter(c => c.id > 0).map(userDetails => {
                const addedUser = taskData.workflowActionTaskAssignees.find(user => user.userId == userDetails.userId);
                if (!addedUser) {
                    taskData.workflowActionTaskAssignees.push({
                        ...userDetails,
                        statusId: 3
                    })
                }
            })
        }

        //Set removed shared with
        if (this.selectedActionTask) {
            this.selectedActionTask.workflowActionTaskSharedWiths.filter(c => c.id > 0).map(userDetails => {
                const addedUser = taskData.workflowActionTaskSharedWiths.find(user => user.userId == userDetails.userId);
                if (!addedUser) {
                    taskData.workflowActionTaskSharedWiths.push({
                        ...userDetails,
                        statusId: 3
                    })
                }
            })
        }

        //Set removed child task
        if (this.selectedActionTask && this.selectedActionTask?.workflowActionChildTasks?.length > 0) {
            this.selectedActionTask.workflowActionChildTasks.filter(c => c.id > 0).map(taskDetails => {
                const addedTask = taskData.workflowActionChildTasks.find(childTask => childTask.id == taskDetails.id);
                if (!addedTask) {
                    taskData.workflowActionChildTasks.push({
                        ...taskDetails,
                        statusId: 3
                    })
                }
            })
        }

        this.taskSaved.emit(taskData);
        this.dialogClose();
    }

    changePriority(selectedPriority: any) {

        let dueDays = 5;

        switch (selectedPriority.value?.id) {
            case 1:
                dueDays = 5;
                break;
            case 2:
                dueDays = 3;
                break;
            case 3:
                dueDays = 1;
                break;
            default:
                break;
        }

        this.taskDetailsForm.patchValue({
            endDateAddOrSubstractValue: dueDays,
        }, { onlySelf: true })
    }

    //#region attachments
    uploadAttachments(files: File[]) {
        this.appMainService.isShowSpinner('upload');
        if (typeof Worker !== undefined) {
            for (let file of files) {
                let errors = validateFiles(file, 2, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error.fileName + ": " + error.error });
                    }
                    this.appMainService.isHideSpinner('upload');
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {

                        let mime_type = this.mimeTypes.find(el => el.extension === extension.toLowerCase());

                        let attachment = {
                            id: 0,
                            createdSource: this.app.userIP,
                            updatedSource: this.app.userIP,
                            createdBy: this.app.user.userId,
                            updatedBy: 0,
                            createdDate: new Date(),
                            updatedDate: new Date(),
                            name: name,
                            guidName: "",
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                            mediaType: mime_type?.value || "",
                            description: "",
                            statusId: Status.Active,
                            isValid: true,
                            moduleName: this.selectedParentModule?.name,
                            isModuleFolder: true
                        };

                        this.attachments.push({
                            workflowActionTaskId: this.taskDetailsForm.value.id,
                            id: 0,
                            fileName: name,
                            displayFileName: name,
                            filePath: name,
                            mediaType: mime_type?.value || "",
                            fileSize: size,
                            statusId: Status.Active,
                            attachment: attachment
                        });
                        this.appMainService.isHideSpinner('upload');
                    });
                }
            }
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
        }
    }

    removeAttachment(attachment: any, index: number) {
        if (attachment?.id > 0) {
            attachment.statusId = Status.Deleted;
        } else {
            this.attachments.splice(index, 1);
        }
    }

    openFilePreview(file: any): void {
        this.displayFilePreview = true;

        const attachment = file?.oldAttachment ? file?.oldAttachment : file?.attachment;

        this.currentFile = {
            ...attachment,
            downloadLink: file.attachment?.content ? file.attachment.content : file?.filePath
        };
    }

    closeFilePreview() {
        this.displayFilePreview = false;
    }

    downloadFile(name: string, content: string, attachmentId: number) {
        let ext = name.substring(name.lastIndexOf('.') + 1);
        ext = ext?.toLowerCase();
        let mime_type = this.mimeTypes.filter(el => el.extension === ext);
        if (mime_type.length > 0 && content) {
            const base64 = content;
            const mime = mime_type[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else if (attachmentId > 0) {
            this.appMainService.isShowSpinner('downloadLink');
            this.documentsService.downloadPublicFile(attachmentId, true).subscribe({
                next: (data) => {
                    this.downloadedFile(data?.downloadLink);
                    this.appMainService.isHideSpinner('downloadLink');
                },
                error: (error: any) => {
                    this.appMainService.isHideSpinner('downloadLink');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "Error occurred while download this file...",
                    });
                }
            })
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: "No content found to download...",
            });
        }
    }

    dataURItoBlob(dataURI: string, mimeType: string) {
        const kept = dataURI.split(",", 2);
        const byteString = atob(kept[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: mimeType });
        return blob;
    }

    downloadedFile(url: string) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        // the filename you want
        a.download = 'todo-1.json';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    openFileNewTab(attachmentDetails: any) {
        if (attachmentDetails?.id > 0) {

            this.appMainService.isShowSpinner('openFilePreview');
            let docType = attachmentDetails.name.substring(attachmentDetails.name.lastIndexOf('.') + 1);
            docType = docType?.toLowerCase();

            this.documentsService.downloadPublicFile(attachmentDetails.id, false).subscribe({
                next: (data) => {
                    switch (docType) {
                        case 'docx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'xlsx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'pptx':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'csv':
                            this.documentViewerService.selectDocumentType(docType, data?.encodedDownloadLink);
                            break;
                        case 'pdf':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'jpg':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'png':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'gif':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        case 'txt':
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                            break;
                        default:
                            this.documentViewerService.selectDocumentType(docType, data?.downloadLink);
                    }
                    this.appMainService.isHideSpinner('openFilePreview');
                },
                error: (error: any) => {
                    this.appMainService.isHideSpinner('openFilePreview');
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: "Error occurred while open this file...",
                    });
                }
            })
        }
    }
    //#endregion attachments

    //Load Dropdown Value
    loadPreLoadedData() {
        this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
        this.repeat = this.app.eventRepeatType;

        if (this.repeat?.length > 0) {
            this.taskDetailsForm.patchValue({
                repeatType: this.repeat[0]
            }, { onlySelf: true, emitEvent: false });
        }
         this.setDefaultValues(this.defaultValuesData);
    }

    loadDropdownValues() {
        this.loadPreLoadedData();

        this.taskService.getReminderDelays().then(delays => {
            this.reminderDelay = delays;
            if (this.reminderDelay?.length > 0) {
                this.taskDetailsForm.patchValue({
                    reminder: this.reminderDelay[0]
                }, { onlySelf: true, emitEvent: false })
            }
        });
        this.taskService.allTaskPriorityList().subscribe({
            next: (response) => {
            this.priority = response;
            this.getAllTaskDefaultValues();  
            },
            error: (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.Message ?? 'Something went wrong'
              });
            }
          })

        this.typeService.getReminderTypes().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(response => {
            this.reminderTypes = response || [];
            this.reminderTypes = this.reminderTypes?.length ? this.reminderTypes.slice(1, this.reminderTypes?.length) : [];
            if (this.reminderTypes?.length > 0) {
                this.taskDetailsForm.patchValue({
                    reminderType: this.reminderTypes[0]
                }, { onlySelf: true, emitEvent: false })
            }
        })

        this.getTaskCategories();
    }
    //#region TaskDefaulvalues

    setDefaultValues(defaultValuesData){
        if (defaultValuesData?.priorityId) {
            const selectedPriority = this.priority.find(priority => priority?.id === defaultValuesData?.priorityId)
            this.taskDetailsForm.patchValue({
                priority: selectedPriority,
            })
        }
        else {
            this.taskDetailsForm.patchValue({
                priority: this.priority[0]
            })
        }
        const selectedUser = this.activeUsers.find(user => user?.id === defaultValuesData?.assignUserId) || null;
        const sharedUsers = this.activeUsers.filter(user =>
            defaultValuesData?.sharedUserId?.includes(user?.id)
        );
        this.taskDetailsForm.patchValue({
            selectedUsers: selectedUser ? [selectedUser] : null,
            taskCategory: this.taskCategories?.length > 0 ? this.taskCategories.find(c => c.id === defaultValuesData.taskCategoryId) || this.taskCategories[0] : null,
            selectedSharedWithUsers: sharedUsers ?? null
        });
        
    }

    getAllTaskDefaultValues() {
        this.appMainService.isShowSpinner('defaultValues');
        this.taskService.getTaskDefaultValues().subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('defaultValues');
                
                this.defaultValuesData= response || {};
                
                if (this.defaultValuesData) {
                    this.setDefaultValues(this.defaultValuesData);
                }
            },
            error: (error) => {
                this.appMainService.isHideSpinner('defaultValues');
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.Message ?? 'something went wrong'
                });
            }
        })
    }

    getTaskCategories(): void {
        this.taskCategoryService.lionO36020APITaskCategoryGet(this.app.user.organizationId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (taskCategories: any[]) => {
                this.taskCategories = taskCategories;

                if (this.taskCategories?.length > 0) {
                    this.taskDetailsForm.patchValue({
                        taskCategory: this.taskCategories[0]
                    }, { onlySelf: true, emitEvent: false })
                }
            }
        })
    }

    // Scroll to error handler function
    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);

        if (!firstElementWithError) {
            const secondElementWithError = document.querySelector('.p-invalid');
            this.scrollTo(secondElementWithError);
        }
    }

    // Scroll to error element
    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    //#region Group Task

    addEditGroupTask(taskDetails: WorkflowModelsNS.WorkflowAddEditActionChildTasks = null, taskIndex: number = -1) {
        this.initGroupTaskDetailsForm(taskDetails);
        this.groupTaskHeader = taskIndex >= 0 ? "Edit Task" : "Add Task";
        this.taskGroupIndex = taskIndex;
        this.displayGroupTaskAddEdit = true;
    }

    initGroupTaskDetailsForm(taskDetails: WorkflowModelsNS.WorkflowAddEditActionChildTasks = null) {
        this.groupDetailsFormErrors = {};
        let selectedUsers = [];
        if (taskDetails?.workflowActionChildTaskAssignees?.length > 0) {
            taskDetails.workflowActionChildTaskAssignees.filter(c => c.statusId == 1).map(userDetails => {
                const selectedUser = this.activeUsers.find(user => user.id == userDetails.userId);
                if (selectedUser) selectedUsers.push(selectedUser);
            });
        }else{
           const  selectedUser = this.activeUsers.find(user => user?.id === this.defaultValuesData?.assignUserId) || null;
            selectedUsers.push(selectedUser);

        }



        this.groupTaskDetailsForm = this.formBuilder.group({
            id: [taskDetails?.id || 0],
            selectedUsers: [selectedUsers?.[0] || null, Validators.required],
            description: [taskDetails?.description || '', Validators.required],
            endDateAddOrSubstractValue: [taskDetails?.endDateAddOrSubstractValue || 5, [Validators.required, convertToAbsolute, convertToInteger]],
        });

        this.loadContentInEditor(taskDetails?.description || "");

        this.groupFormErrorHandler.handleErrors(this.groupTaskDetailsForm, this.groupDetailsFormErrors, {
            description: {
                required: "Enter Task Details",
            },
            selectedUsers: {
                required: "Select Assign To",
            },
            endDateAddOrSubstractValue: {
                required: "Enter end day",
                min: "End day can't be less than start day"
            }
        });
    }

    saveGroupTask() {
        if (this.groupTaskDetailsForm.invalid) {
            this.groupFormErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }

        const formData = this.groupTaskDetailsForm.getRawValue();
        const taskOrder = this.groupChildTasks?.length > 0 ? this.groupChildTasks[this.groupChildTasks?.length - 1].taskOrder + 1 : 0;
        const taskDetails: WorkflowModelsNS.WorkflowAddEditActionChildTasks = {
            id: 0,
            statusId: Status.Active,
            workflowActionTaskId: this.taskDetailsForm.value.id,
            description: formData.description,
            startDateBaseFieldName: this.taskDetailsForm.getRawValue().startDateBaseField.fieldName,
            endDateAddOrSubstractValue: formData.endDateAddOrSubstractValue,
            taskOrder: taskOrder,
            prority: this.taskDetailsForm.getRawValue().priority?.id || null,
            assignedType: this.assignedTypes[0].id,
            workflowActionChildTaskAssignees: []
        }

        const selectedTask = (this.taskGroupIndex >= 0) ? this.groupChildTasks[this.taskGroupIndex] : null;

        const selectedUsers = formData?.selectedUsers ? [formData.selectedUsers] : [];
        selectedUsers.map(userDetails => {
            let id = 0;
            if (selectedTask) {
                const addedUser = selectedTask.workflowActionChildTaskAssignees.find(user => user.userId == userDetails.id);
                id = addedUser?.id || 0;
            }

            taskDetails.workflowActionChildTaskAssignees.push({
                id: id,
                workflowActionChildTaskId: selectedTask?.id || 0,
                userId: userDetails.id,
                name: userDetails.name,
                statusId: 1
            })
        });

        //Set removed
        if (selectedTask) {
            selectedTask.workflowActionChildTaskAssignees.filter(c => c?.id > 0).map(userDetails => {
                const addedUser = taskDetails.workflowActionChildTaskAssignees.find(user => user.userId == userDetails.userId);
                if (!addedUser) {
                    taskDetails.workflowActionChildTaskAssignees.push({
                        ...userDetails,
                        statusId: 3
                    })
                }
            })
        }

        if (this.taskGroupIndex >= 0) {
            const selectedTask = this.groupChildTasks[this.taskGroupIndex];
            selectedTask.description = taskDetails.description;
            selectedTask.endDateAddOrSubstractValue = taskDetails.endDateAddOrSubstractValue;
            selectedTask.workflowActionChildTaskAssignees = taskDetails.workflowActionChildTaskAssignees;
        } else {
            this.groupChildTasks.push(taskDetails);
        }
        this.groupTaskErrorMsg = "";
        this.displayGroupTaskAddEdit = false;
    }

    removeGroupTask(index: number) {
        this.groupChildTasks.splice(index, 1);
    }

    loadContentInEditor(text: any, updateSelf: boolean = false) {
        if (updateSelf) {
            this.groupTaskDetailsForm.patchValue({
                description: text
            })
        }
        setTimeout(() => {
            const _quill = this.editor.getQuill();
            const editorContainer = _quill.root;
            this.renderer.setProperty(editorContainer, 'innerHTML', text);
        })
    }

    dragNDrop(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
    //#endregion Group Task

    //#region category
    displayAddTaskCategory: boolean = false;
    addTaskCategoryForm: FormGroup = new FormGroup({});
    categoryFormErrorHandler: FormErrorHandler = new FormErrorHandler();
    categoryDetailsFormErrors: any = {};
    loadingTaskSave: boolean = false;

    addNewCategory(e) {
        this.displayAddTaskCategory = true;
        this.initAddTaskCategoryForm();
    }

    initAddTaskCategoryForm() {
        this.categoryDetailsFormErrors = {};
        this.addTaskCategoryForm = this.formBuilder.group({
            categoryName: [null, Validators.required]
        });
        this.categoryFormErrorHandler.handleErrors(this.addTaskCategoryForm, this.categoryDetailsFormErrors, {
            categoryName: {
                required: 'Category name is required'
            },

        });
    }

    validateNewTaskCategory() {
        const categoryName = this.addTaskCategoryForm.get('categoryName').value.trim();
        const categoryExists = this.taskCategories.some(cat => cat.category.name == categoryName);
        if (categoryExists) {
            this.categoryDetailsFormErrors = { categoryName: 'This task category already exists' };
            return true;
        }

        this.categoryDetailsFormErrors = null;
         return false;
    }

    saveNewTaskCategory() {
        if (this.addTaskCategoryForm.invalid || this.validateNewTaskCategory()) {
            this.categoryFormErrorHandler.showErrorOnSubmit();
            this.scrollToError();
            return; //Return if form invalid
        }
        const categoryName = this.addTaskCategoryForm.get('categoryName').value.trim();
        const newCategory = {
            name: categoryName
        }
        this.taskCategoryService.addNewTaskCategoryGet(newCategory).subscribe({
            next: (response) => {
                this.appMainService.isHideSpinner('newTaskCategory');
                this.loadingTaskSave = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'New Task Category Added Successfully'
                });
                this.addTaskCategoryForm.reset();
                this.displayAddTaskCategory = false;
                this.getTaskCategories();
            },
            error: (error) => {
                this.appMainService.isHideSpinner('newTaskCategory');
                this.loadingTaskSave = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error?.error?.message ? error?.error?.message : 'Failed To Create New Task Category'
                });
            }
        })
    }

    cancelNewTaskCategory() {
        this.addTaskCategoryForm.reset();
        this.displayAddTaskCategory = false;
    }
    //#endregion

}
